<div class="flex flex-col gap-3 h-full min-h-0">
  <div class="flex items-center gap-2 shrink-0">
    <p-iconfield class="w-full">
      <p-inputicon styleClass="pi pi-search" />
      <input
        pInputText
        type="search"
        maxlength="255"
        [formControl]="searchQuery"
        placeholder="Search filename, owner, or customer…"
        aria-label="Search CAD files"
        class="w-full"
      />
    </p-iconfield>
    <p-button
      icon="pi pi-refresh"
      severity="secondary"
      [outlined]="true"
      (onClick)="refreshStorageFiles()"
      pTooltip="Refresh Storage"
    />
  </div>

  @if (loadingStorage) {
    <div class="text-sm text-muted-color py-6 text-center flex-1">
      <i class="pi pi-spinner pi-spin mr-2"></i>
      Loading Storage files...
    </div>
  } @else if (loadError) {
    <div
      class="text-sm text-red-500 py-6 flex-1 flex flex-col items-center gap-3"
    >
      {{ loadError }}
      <p-button
        label="Retry"
        severity="secondary"
        [outlined]="true"
        (onClick)="loadStorageFiles()"
      />
    </div>
  } @else if (storageFiles.length === 0) {
    <div class="text-sm text-muted-color py-6 text-center flex-1">
      @if (activeSearch) {
        No CAD files match your search.
      } @else {
        No CAD files in storage.
      }
    </div>
  } @else {
    <div
      class="flex-1 min-h-0 overflow-y-auto border border-surface-switch-200 rounded-md"
    >
      @for (cadFile of storageFiles; track cadFile.id) {
        <button
          type="button"
          class="w-full text-left p-3 border-b border-surface-switch-200 last:border-b-0 hover:bg-surface-switch-50"
          [attr.aria-pressed]="isSelected(cadFile.id)"
          [class.bg-primary-50]="isSelected(cadFile.id)"
          (click)="toggleExistingCadFileSelection(cadFile)"
        >
          <div class="flex items-center justify-between gap-3">
            <div class="min-w-0">
              <div class="font-semibold truncate">
                {{ cadFile.filename }}
              </div>
              <div class="text-xs text-muted-color truncate">
                Owner: {{ cadFile.owner }} | Uploaded:
                {{ cadFile.created_date | date: "medium" }} | Company:
                {{ cadFile.company_name || "None" }}
              </div>
            </div>
            <i
              class="pi"
              [class.pi-check-circle]="isSelected(cadFile.id)"
              [class.pi-circle]="!isSelected(cadFile.id)"
            ></i>
          </div>
        </button>
      }
    </div>
  }

  <div
    class="shrink-0 flex flex-wrap items-center justify-between gap-3 pt-3 border-t border-surface-switch-200"
  >
    <p-paginator
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} of {totalRecords}"
      (onPageChange)="onPageChange($event)"
    />
    <p-button
      [label]="useSelectedLabel"
      icon="pi pi-arrow-right"
      [disabled]="selectedCadFileIds.size === 0 || loadingSelectedExisting"
      [loading]="loadingSelectedExisting"
      (onClick)="useSelectedExistingCadFiles()"
    />
  </div>

  @if (storageError) {
    <p class="text-sm text-red-500 mt-2">{{ storageError }}</p>
  }
</div>
